export const WORKSHEET_CONSTANTS = {
    MODE_SINGLE: 'single',
    MODE_COLLAB: 'collab',
};